import { render, staticRenderFns } from "./public-activity-details.vue?vue&type=template&id=968cff6a&scoped=true&"
import script from "./public-activity-details.ts?vue&type=script&lang=ts&"
export * from "./public-activity-details.ts?vue&type=script&lang=ts&"
import style0 from "./public-activity-details.scss?vue&type=style&index=0&id=968cff6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968cff6a",
  null
  
)

export default component.exports